export type DustErrorCode =
  | "core_api_error"
  | "ambiguous_provider_effect"
  | "quota_exceeded"
  | "internal_error"
  | "invalid_id"
  | "limit_reached"
  | "connection_not_found"
  | "file_not_found"
  | "unauthorized"
  | "agent_loop_already_running"
  | "compaction_already_running"
  | "data_source_not_found"
  | "data_source_view_not_found"
  | "space_not_found"
  | "invalid_request_error"
  // Data source
  | "data_source_error"
  | "data_source_quota_error"
  | "invalid_parent_id"
  | "invalid_parents"
  | "invalid_title_in_tags"
  | "invalid_url"
  | "text_or_section_required"
  | "title_is_empty"
  | "title_too_long"
  | "invalid_file"
  | "file_not_ready"
  // Table
  | "invalid_rows"
  | "missing_csv"
  | "invalid_csv_content"
  | "invalid_csv_and_file"
  | "invalid_content_error"
  | "table_not_found"
  // Group errors
  | "system_or_global_group"
  | "user_already_member"
  | "user_not_found"
  | "user_not_member"
  | "group_requirements_not_met"
  | "group_not_found"
  | "invalid_group_kind"
  // MCP Server errors
  | "remote_server_not_found"
  | "internal_server_not_found"
  | "mcp_server_view_not_found"
  | "name_conflict"
  | "action_not_found"
  | "action_not_blocked"
  | "action_not_editable"
  | "invalid_edited_arguments"
  | "mcp_access_token_error"
  // Triggers errors
  | "webhook_source_not_found"
  // Activation errors
  | "activation_work_area_not_found"
  // Space errors
  | "space_already_exists"
  // Conversation errors
  | "conversation_not_found"
  | "failed_to_copy_files"
  | "no_unread_messages_found"
  | "no_blocked_actions"
  | "agent_message_not_resumable"
  | "no_whitelisted_model_found"
  | "generation_failed"
  | "invalid_conversation"
  | "conversation_agent_running"
  // Subscription / billing errors
  | "subscription_already_exists"
  | "workspace_not_found"
  | "plan_not_found"
  | "metronome_error"
  | "coupon_redemption_error";

export class DustError<T extends DustErrorCode = DustErrorCode> extends Error {
  constructor(
    readonly code: T,
    message: string
  ) {
    super(message);
  }
}
